const tpl = (t, d) => t.replace(/\{([\w\W]+?)\}/g, (str, key) => {
  let value = d[key];
  if (value === undefined) {
    value = "{" + key + "}";
  } else if (typeof value === 'function') {
    value = value(data);
  }
  return value;
})

export const BOUNDS_TYPE = {
  RECT: Symbol(),
  CIRCLE: Symbol()
}

const interval = (a,b) => {
  a = new Date(a).getTime()
  b = new Date(b).getTime()
  if(!isNaN(a) && !isNaN(b) && a && b){
    return (b - a) / 3600000
  }else{
    return -1
  }
}

const timestamp = (a) => {
  let d = new Date(a).getTime()
  if(isNaN(d)){
    return Date.now()
  }else{
    return d
  }
}

class Poi {
  constructor(map, options = { iwTpl: '', moveMode: false, poiTpl: '', size: [48, 48], offset: [-16, -37], handlers: {} }) {
    this.map = map
    //已显示的
    this.pois = {}
    this.data = []
    this.iw = null
    this.extendRate = 1.2
    this.options = options
    this.size = options.size
    this.offset = options.offset

    this.topZIndex = 10000
    this.moveMode = options.moveMode
    this.iw = new AMap.InfoWindow({
      isCustom: true, //使用自定义窗体
      content: '',
      offset: new AMap.Pixel(0, -45)
    });

    let custom = this.custom_fn = '_sl_map_info_window_info' + Date.now()
    window[custom] = this.close.bind(this)

    this.handlers = { ...options.handlers, 'close_iw': `window['${custom}']()` }
  }

  destroy() {
    if (this.custom_fn) {
      delete window[this.custom_fn]
    }

    for(let id in this.pois){
      this.remove(id)
    }

    this.pois = {}
    this.data = []

    this.iw = null
  }



  //设置类型状态
  setType(type , state){
    for(let i of this.data){
      if(i.mixState == type){
        i.visible = state
      }
    }
    this.load( this.data )
  }

  //有数据时更新
  // 1.更新存在的点 , 更新显示状态
  // 2.移除不存在的点
  // 3.新增点
  load(raw) {
    //过滤有效点
    let data = raw.map(i => ({
      ...i ,
      position:new AMap.LngLat(i.lng, i.lat),
      //currentTrackId:(i.tracks && i.tracks.length) ? i.tracks[i.tracks.length-1].id : 0,
      //currentRecordTime:(i.tracks && i.tracks.length) ? timestamp(i.tracks[i.tracks.length-1].recordDatetime) : Date.now(),

      //轨迹时间转 timestrap
      tracks: i.history ? i.history.map(i => ({...i , recordDatetime:timestamp(i.time)})) : []
      // tracks: [{latitude:i.latitude+Math.random() / 10, longitude:i.longitude + Math.random() / 10 , recordDatetime:Date.now() + 1000 + 1000*Math.random()}]
    }))

    //与现有的点 比对
    if( this.data.length && this.moveMode){
      for(let i of data){
        //update 存在的点 将新轨迹追加到队列
        if(this.pois[i.id]){
          this.saveTrack(i, this.pois[i.id].getExtData())
        }
      }
      this.data = data
    }
    //初次加载 快速处理
    else{
      this.data = data
    }


    // create & remove
    this.update()
  }

  //更新已有点
  updatePoi(data) {
    const poi = this.pois[data.id]
    if (poi) {
      const poiData = poi.getExtData()
      this.saveTrack(data, poiData)
    }
  }

  //缓存轨迹数据
  // @newData 新增tracks
  // @poiData 
  saveTrack(newData, poiData) {
    if (newData.tracks && newData.tracks.length > 0) {
      let lastCacheTime = poiData.tracks.length ? poiData.tracks[poiData.tracks.length-1].recordDatetime : poiData.currentRecord
      //tracks = []
      // if( !lastCacheTime ){
      //   if( newData.tracks && newData.tracks.length ){
      //     lastCacheTime = newData.tracks[0]
      //   }else{
      //     return
      //   }
      // }

      let routes = newData.tracks.filter(i => i.recordDatetime > lastCacheTime)
      poiData.tracks.push(...routes)

      this.updateTrack(poiData)
    }
  }

  //poi播放下一条轨迹
  updateTrack(poiData) {
    const poi = this.pois[poiData.id]
    //
    if (poi && poiData.moving == false && poiData.tracks.length) {
      let point = poiData.tracks.shift()

      let nextPosition = new AMap.LngLat(point.lng, point.lat)
      // km / h
      let calcSpeed = point.speed || 50
      let nextInterval = interval( poiData.currentRecord , point.recordDatetime)
      let nextDistance = poi.getPosition().distance(nextPosition) / 1000
      if( nextInterval > 0 ){
        calcSpeed = nextDistance / nextInterval
      }
      if( calcSpeed <= 0 ) calcSpeed = 40
      
      //console.log(poiData.carNo,nextInterval+'h', nextDistance.toFixed(2)+'km', '--->',calcSpeed.toFixed(2)+'km/h')

      poiData.currentRecord = point.recordDatetime
      poiData.moving = true

      poi.moveTo(nextPosition, calcSpeed)
    }
  }

  //设置focus poi
  focus(id) {
    if (this.pois[id]) {
      this.pois[id].setzIndex(this.topZIndex++)
    }
  }

  getBounds(conv, isCircle = false, wrap = true) {
    let rate = this.extendRate
    let def = this.map.getBounds()
    let sw = def.getSouthWest()
    let ne = def.getNorthEast()
    let c = def.getCenter()

    if (!isCircle) {
      let dx = ne.getLng() - sw.getLng()
      let dy = ne.getLat() - sw.getLat()
      let nsw = new AMap.LngLat(sw.getLng() - rate * dx / 2, sw.getLat() - rate * dy / 2)
      let nne = new AMap.LngLat(ne.getLng() + rate * dx / 2, ne.getLat() + rate * dy / 2)
      if (conv) {
        let r = { minLat: nsw.getLat(), minLng: nsw.getLng(), maxLat: nne.getLat(), maxLng: nne.getLng() }
        if (r.maxLng < 0) {
          //let t = r.maxLng
          r.maxLng = 360 + r.maxLng
          //r.minLng  = t
        }

        return r
      } else
        return new AMap.Bounds(nsw, nne)
    } else {
      let r = c.distance(ne)
      if (conv) {
        return {
          center: [c.getLat(), c.getLng()],
          radius: r
        }
      }
    }
    // 阔咋喊
  }

  add(data) {
    let extData = { ...data , moving:false }

    //新增时，不缓存
    extData.tracks = [ ]
    extData.currentRecord = data.tracks.length ? data.tracks.pop().recordDatetime : Date.now()
    let marker = new AMap.Marker({
      position: data.position,
      content: tpl(this.options.poiTpl, data),
      offset: new AMap.Pixel(this.offset[0], this.offset[1]),
      extData: extData
    })

    marker.setMap(this.map)
    marker.on('click', this.onMarkerClick, this);
    marker.on('moveend', () => {
      this.onMarkerMoveend(data.id)
    }, this);

    this.pois[data.id] = marker

    return marker
  }

  remove(id) {
    // console.log('remove', id)
    let marker = this.pois[id]
    if (marker) {
      marker.stopMove()
      marker.setMap(null)
      delete this.pois[id]
    }
  }

  update() {
    let { map, pois } = this

    // 检测 poi 更新
    if (!this.lastZoom) this.lastZoom = map.getZoom()

    //获取可显示点
    let renderList = this.getRenderables() || [],
      exist = {};
    
    //移除不在显示范围的
    for (let id in pois) {
      if (renderList.find(i => i.id == id)) {
        exist[id] = true;
      } else {
        this.remove(id);
      }
    }

    renderList.forEach(i => {
      // 添加新点
      if (!exist[i.id]) {
        this.add(i);
      }
      //更新已有点的位置
      else {
        if (this.moveMode) {
          this.updatePoi(i)
        }
      }
    })

    this.lastZoom = map.getZoom();

    this.render_handler = undefined;
  }
  onMarkerClick(e) {
    this.open(e.target.getExtData(), e.target.getPosition())
  }

  onMarkerMoveend(id) {
    let poi = this.pois[id]
    let poiData = poi.getExtData()
    poiData.moving = false
    this.updateTrack(poiData);
  }

  open(data, position) {
    let d = Object.assign({}, data)
    if (this.handlers.open) {
      this.handlers.open(d)
    } else {
      this.iw.setContent(tpl(tpl(this.options.iwTpl, this.handlers), d))
      this.iw.open(this.map, position)
    }

    this.map.panTo(position)
  }
  close() {
    this.map.clearInfoWindow()
  }
  //返回需要显示的poi
  getRenderables() {
    let { map, lastZoom, pois } = this
    let bound = this.getBounds()

    //筛选范围内的
    let renderables = this.data.filter(i => i.visible && bound.contains(i.position))

    // 最高级别 视野内的全部显示
    if (map.getZoom() == 17) {
      return renderables;
    }

    //renderList 显示集（显示的点） ， preList（预显示点）
    let renderList = [],
      preList = []

    //平移时
    if (map.getZoom() >= lastZoom) {
      // 已存在点 和 所有的点 取交集，
      renderables.forEach(i => {
        let id = i.id
        //已存在显示列表内的poi
        if (pois[id]) {
          //if (renderList == undefined) renderList = {}
          renderList.push(i) //[id] = i
        } else {
          preList.push(i)
        }
      })

    }
    //缩放时，所有都要处理
    else {
      preList = renderables;
    }

    if (renderList.length == 0 && preList.length) {
      renderList[0] = preList[0]
    }

    preList.forEach(i => {
      if (!renderList.some(j => this.intersect(j.position, i.position))) {
        renderList.push(i)
      }
    })
    /*
      [].concat(renderList,
        preList.filter( i => {
          return !renderList.some(j => this.intersect(j.position, i.position))
        })
      )
    */

    return Object.values(renderList);
  }

  //判断某两个位置 在屏幕视图中是否遮挡
  intersect(h, v) {
    let px = this.map.lnglatToPixel(v)
    let hx = this.map.lnglatToPixel(h)
    let [x, y] = this.size
    return ((Math.abs(hx.x - px.x) < x) && (Math.abs(hx.y - px.y) < y))
  }

  hide(){
    for(let id in this.pois){
      this.pois[id].hide()
    }
  }

  show(){
    for(let id in this.pois){
      let poi = this.pois[id]
      let poiData = poi.getExtData()
      if(poiData.visible){
        poi.show()
      }
    }
  }

  clear(){
    this.data = []
    for(let id in this.pois){
      let marker = this.pois[id]
      if (marker) {
        marker.stopMove()
        marker.setMap(null)
        delete this.pois[id]
      }
    }
  }
}

export default Poi